import VueRouter from 'vue-router'
//引入组件
import Index from '../pages'
import Home from '../pages/home/home'
import Login from '../pages/login/login'
import Register from '../pages/register/register'
import Center from '../pages/center/center'
import Forum from '../pages/forum/list'
import ForumAdd from '../pages/forum/add'
import ForumDetail from '../pages/forum/detail'
import MyForumList from '../pages/forum/myForumList'
import Storeup from '../pages/storeup/list'
import AddrList from '../pages/shop-address/list'
import AddrAdd from '../pages/shop-address/addOrUpdate'
import Order from '../pages/shop-order/list'
import OrderConfirm from '../pages/shop-order/confirm'
import Cart from '../pages/shop-cart/list'
import payList from '../pages/pay'

import keshifenleiList from '../pages/keshifenlei/list'
import keshifenleiDetail from '../pages/keshifenlei/detail'
import keshifenleiAdd from '../pages/keshifenlei/add'
import yonghuList from '../pages/yonghu/list'
import yonghuDetail from '../pages/yonghu/detail'
import yonghuAdd from '../pages/yonghu/add'
import yishengList from '../pages/yisheng/list'
import yishengDetail from '../pages/yisheng/detail'
import yishengAdd from '../pages/yisheng/add'
import wenzhenzixunList from '../pages/wenzhenzixun/list'
import wenzhenzixunDetail from '../pages/wenzhenzixun/detail'
import wenzhenzixunAdd from '../pages/wenzhenzixun/add'
import jiezhenhuifuList from '../pages/jiezhenhuifu/list'
import jiezhenhuifuDetail from '../pages/jiezhenhuifu/detail'
import jiezhenhuifuAdd from '../pages/jiezhenhuifu/add'
import yaofangkaijuList from '../pages/yaofangkaiju/list'
import yaofangkaijuDetail from '../pages/yaofangkaiju/detail'
import yaofangkaijuAdd from '../pages/yaofangkaiju/add'
import yaopinfenleiList from '../pages/yaopinfenlei/list'
import yaopinfenleiDetail from '../pages/yaopinfenlei/detail'
import yaopinfenleiAdd from '../pages/yaopinfenlei/add'
import yaofangxinxiList from '../pages/yaofangxinxi/list'
import yaofangxinxiDetail from '../pages/yaofangxinxi/detail'
import yaofangxinxiAdd from '../pages/yaofangxinxi/add'
import yaopinxinxiList from '../pages/yaopinxinxi/list'
import yaopinxinxiDetail from '../pages/yaopinxinxi/detail'
import yaopinxinxiAdd from '../pages/yaopinxinxi/add'
import zhongyizhishiList from '../pages/zhongyizhishi/list'
import zhongyizhishiDetail from '../pages/zhongyizhishi/detail'
import zhongyizhishiAdd from '../pages/zhongyizhishi/add'
import zhishileixingList from '../pages/zhishileixing/list'
import zhishileixingDetail from '../pages/zhishileixing/detail'
import zhishileixingAdd from '../pages/zhishileixing/add'
import forumtypeList from '../pages/forumtype/list'
import forumtypeDetail from '../pages/forumtype/detail'
import forumtypeAdd from '../pages/forumtype/add'
import forumreportList from '../pages/forumreport/list'
import forumreportDetail from '../pages/forumreport/detail'
import forumreportAdd from '../pages/forumreport/add'
import chargerecordList from '../pages/chargerecord/list'
import chargerecordDetail from '../pages/chargerecord/detail'
import chargerecordAdd from '../pages/chargerecord/add'
import aboutusList from '../pages/aboutus/list'
import aboutusDetail from '../pages/aboutus/detail'
import aboutusAdd from '../pages/aboutus/add'
import discussyaofangxinxiList from '../pages/discussyaofangxinxi/list'
import discussyaofangxinxiDetail from '../pages/discussyaofangxinxi/detail'
import discussyaofangxinxiAdd from '../pages/discussyaofangxinxi/add'
import discussyaopinxinxiList from '../pages/discussyaopinxinxi/list'
import discussyaopinxinxiDetail from '../pages/discussyaopinxinxi/detail'
import discussyaopinxinxiAdd from '../pages/discussyaopinxinxi/add'
import discusszhongyizhishiList from '../pages/discusszhongyizhishi/list'
import discusszhongyizhishiDetail from '../pages/discusszhongyizhishi/detail'
import discusszhongyizhishiAdd from '../pages/discusszhongyizhishi/add'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

//配置路由
export default new VueRouter({
	routes:[
		{
      path: '/',
      redirect: '/index/home'
    },
		{
			path: '/index',
			component: Index,
			children:[
				{
					path: 'home',
					component: Home
				},
				{
					path: 'center',
					component: Center,
				},
				{
					path: 'pay',
					component: payList,
				},
				{
					path: 'forum',
					component: Forum
				},
				{
					path: 'forumAdd',
					component: ForumAdd
				},
				{
					path: 'forumDetail',
					component: ForumDetail
				},
				{
					path: 'myForumList',
					component: MyForumList
				},
				{
					path: 'storeup',
					component: Storeup
				},
                {
                    path: 'shop-address/list',
                    component: AddrList
                },
                {
                    path: 'shop-address/addOrUpdate',
                    component: AddrAdd
                },
				{
					path: 'shop-order/order',
					component: Order
				},
				{
					path: 'cart',
					component: Cart
				},
				{
					path: 'shop-order/orderConfirm',
					component: OrderConfirm
				},
				{
					path: 'keshifenlei',
					component: keshifenleiList
				},
				{
					path: 'keshifenleiDetail',
					component: keshifenleiDetail
				},
				{
					path: 'keshifenleiAdd',
					component: keshifenleiAdd
				},
				{
					path: 'yonghu',
					component: yonghuList
				},
				{
					path: 'yonghuDetail',
					component: yonghuDetail
				},
				{
					path: 'yonghuAdd',
					component: yonghuAdd
				},
				{
					path: 'yisheng',
					component: yishengList
				},
				{
					path: 'yishengDetail',
					component: yishengDetail
				},
				{
					path: 'yishengAdd',
					component: yishengAdd
				},
				{
					path: 'wenzhenzixun',
					component: wenzhenzixunList
				},
				{
					path: 'wenzhenzixunDetail',
					component: wenzhenzixunDetail
				},
				{
					path: 'wenzhenzixunAdd',
					component: wenzhenzixunAdd
				},
				{
					path: 'jiezhenhuifu',
					component: jiezhenhuifuList
				},
				{
					path: 'jiezhenhuifuDetail',
					component: jiezhenhuifuDetail
				},
				{
					path: 'jiezhenhuifuAdd',
					component: jiezhenhuifuAdd
				},
				{
					path: 'yaofangkaiju',
					component: yaofangkaijuList
				},
				{
					path: 'yaofangkaijuDetail',
					component: yaofangkaijuDetail
				},
				{
					path: 'yaofangkaijuAdd',
					component: yaofangkaijuAdd
				},
				{
					path: 'yaopinfenlei',
					component: yaopinfenleiList
				},
				{
					path: 'yaopinfenleiDetail',
					component: yaopinfenleiDetail
				},
				{
					path: 'yaopinfenleiAdd',
					component: yaopinfenleiAdd
				},
				{
					path: 'yaofangxinxi',
					component: yaofangxinxiList
				},
				{
					path: 'yaofangxinxiDetail',
					component: yaofangxinxiDetail
				},
				{
					path: 'yaofangxinxiAdd',
					component: yaofangxinxiAdd
				},
				{
					path: 'yaopinxinxi',
					component: yaopinxinxiList
				},
				{
					path: 'yaopinxinxiDetail',
					component: yaopinxinxiDetail
				},
				{
					path: 'yaopinxinxiAdd',
					component: yaopinxinxiAdd
				},
				{
					path: 'zhongyizhishi',
					component: zhongyizhishiList
				},
				{
					path: 'zhongyizhishiDetail',
					component: zhongyizhishiDetail
				},
				{
					path: 'zhongyizhishiAdd',
					component: zhongyizhishiAdd
				},
				{
					path: 'zhishileixing',
					component: zhishileixingList
				},
				{
					path: 'zhishileixingDetail',
					component: zhishileixingDetail
				},
				{
					path: 'zhishileixingAdd',
					component: zhishileixingAdd
				},
				{
					path: 'forumtype',
					component: forumtypeList
				},
				{
					path: 'forumtypeDetail',
					component: forumtypeDetail
				},
				{
					path: 'forumtypeAdd',
					component: forumtypeAdd
				},
				{
					path: 'forumreport',
					component: forumreportList
				},
				{
					path: 'forumreportDetail',
					component: forumreportDetail
				},
				{
					path: 'forumreportAdd',
					component: forumreportAdd
				},
				{
					path: 'chargerecord',
					component: chargerecordList
				},
				{
					path: 'chargerecordDetail',
					component: chargerecordDetail
				},
				{
					path: 'chargerecordAdd',
					component: chargerecordAdd
				},
				{
					path: 'aboutus',
					component: aboutusList
				},
				{
					path: 'aboutusDetail',
					component: aboutusDetail
				},
				{
					path: 'aboutusAdd',
					component: aboutusAdd
				},
				{
					path: 'discussyaofangxinxi',
					component: discussyaofangxinxiList
				},
				{
					path: 'discussyaofangxinxiDetail',
					component: discussyaofangxinxiDetail
				},
				{
					path: 'discussyaofangxinxiAdd',
					component: discussyaofangxinxiAdd
				},
				{
					path: 'discussyaopinxinxi',
					component: discussyaopinxinxiList
				},
				{
					path: 'discussyaopinxinxiDetail',
					component: discussyaopinxinxiDetail
				},
				{
					path: 'discussyaopinxinxiAdd',
					component: discussyaopinxinxiAdd
				},
				{
					path: 'discusszhongyizhishi',
					component: discusszhongyizhishiList
				},
				{
					path: 'discusszhongyizhishiDetail',
					component: discusszhongyizhishiDetail
				},
				{
					path: 'discusszhongyizhishiAdd',
					component: discusszhongyizhishiAdd
				},
			]
		},
		{
			path: '/login',
			component: Login
		},
		{
			path: '/register',
			component: Register
		},
	]
})
